// "Routines" are marketed as "Agents" in the UI; the code name remains "routines".
import React from 'react';

import {ChatSettingsTab} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {chatSettingsModalUrl} from 'llm/routes/UrlUtils';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {ChipItem, SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {apiIdToIconName} from 'util/APIUtil';

/**
 * Smart chip for a routine ("Agent"), rendered from a `<bnch_id>rtn_…</bnch_id>` reference. Fetches
 * the agent's current name and, on click, deep-links to its config in the redesign chat-settings
 * modal. Routines have no standalone model URL, so the URL is the `/chats/settings/agents/<id>`
 * route — whose AIRoutes handler is gated on LLM_ENABLE_CHAT_REDESIGN.
 */
export default function RoutineChip(props: SharedSmartChipProps<SmartChipType.ROUTINE>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: routine,
    handleClickLink,
    isInaccessible,
    itemUrl: routineUrl,
  } = useSmartChipQuery<SmartChipType.ROUTINE>({
    id,
    onClick,
    getUrlFn: (item: ChipItem<SmartChipType.ROUTINE>) =>
      chatSettingsModalUrl(ChatSettingsTab.AGENTS, {selectedItemId: item.id}),
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={routine != null ? apiIdToIconName(routine.id) : null}
      isInaccessible={isInaccessible}
      item={routine}
      onClick={handleClickLink}
      url={routineUrl}
    />
  );
}
